// extracted by mini-css-extract-plugin
export default {"heading":"sw-z","corrected":"tw-z","redirectVerbiageContainer":"uw-z","redirectVerbiageText":"vw-z"};